module.exports = __webpack_public_path__ + "img/motion_sensor_white.d4cc851d.svg";